<template lang="pug">
.post-sticker.row.center.between(v-if="data" :class="[data.status]" @click="$emit('click',$event); $emit('select',$el);" @mouseover="hover = true"  @mouseleave="hover = false")
  img.content-indicator(v-if="data.content_type" :src="$root.icons[data.content_type]")
  .sponsor-indicator(v-if="data.sponsor_budget")
  .title.column.center.left
    .text(v-html="hover ? new Date(data.date).format('%H:%M') : data.title")
  .networks.row.center(v-if="data.networks && data.networks.length <= 3")
    .icon.row.center(v-for="network in data.networks" :class="network")
      svg-icon(name="blog" v-if="network === 'blog'")
      svg-icon(name="newsletter" v-else-if="network === 'newsletter'")
      img(:src="$root.icons.presse" v-else-if="network === 'presse'")
      font-awesome-icon(v-else :icon="$root.icons[network]")
  .networks.row.center(v-else style="width: 24px; font-weight: bold;") {{ data.networks && data.networks.length }}
    //- .circle(v-for="network in data.networks" :class="network")
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      hover: false,
    }
  }
}
</script>
<style>
.post-sticker {
  border-radius: 10px;
  height: 38px;
  padding: 4px;
  position: relative;
}
.post-sticker .sponsor-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--secondary);
  position: absolute;
  top:-4px;
  right: -2px;
}
.post-sticker .content-indicator {
  width: 14px;
  height: 14px;
  position: absolute;
  top:-7px;
  right: 8px;
}
.post-sticker.selected {
  /* border: 2px solid var(--primary); */
  /* box-shadow: var(--box-shadow); */
  /* padding: 2px; */
}
.post-sticker:hover {
  cursor: pointer;
}
.post-sticker .title {
  line-height: 1;
  height: 100%;
  overflow: hidden;
  flex: 1;
}
.post-sticker .title .text {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.post-sticker .title.date {
  display: none;

}
.post-sticker:hover .title.date {
  display: inherit;
}
.post-sticker .title.text {
  display: inherit;
}
.post-sticker:hover .title.text {
  display: none;
}
.post-sticker.draft {
  background: white;
  border: 2px solid var(--darkgrey);
}
.post-sticker.unconfirmed {
  background: var(--lightgrey);
}
.post-sticker.confirmed {
  background: var(--green-bg);
}
.post-sticker.wip {
  background: var(--orange-bg);
}
.post-sticker.denied {
  background: var(--red-bg);
}
.post-sticker .networks {
  border-radius: 12px;
  padding: 0 4px;
  background: white;
  height: 24px;
}
/* .post-sticker .networks .icon {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  background: blue;
  color: white;
  margin: 0 2px;
}
.post-sticker .networks .icon svg {
  height: 12px!important;
  width: 12px!important;
} */
.post-sticker .all-networks {
  width: 36px;
  font-weight: bold;
}
.post-sticker .circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-right: 3px;
}
.post-sticker .networks .icon {
  width: 18px;
  height: 18px;
  padding: 3px;
  margin-right: 3px;
  border-radius: 50%;
  color: white;
}
.post-sticker .circle:last-child {
  margin-right: 0;
}
.post-sticker .icon.facebook {
  background: var(--facebook-bg);
}


.post-sticker .icon.facebook_story {
  background: white;
  border: 2px solid #3e5c9a;
  color: #3e5c9a;
}
.post-sticker .icon.instagram_story {
  background: white;
  border: 2px solid #E1306C;
  color: #E1306C;
}
.post-sticker .icon.blog {
  background: white;
  border: 2px solid #F7A813;
  padding: 1px;
}
.post-sticker .icon.presse {
  background: white;
  border: 2px solid #4EC1EF;
  padding: 1px;
}
.post-sticker .icon.newsletter {
  background: white;
  border: 2px solid #65AF56;
  padding: 1px;
}

.post-sticker .icon.twitter {
  background: var(--twitter-bg);
}
.post-sticker .icon.instagram {
  background: var(--instagram-bg);
}
.post-sticker .icon.linkedin {
  background: var(--linkedin-bg);
}
.post-sticker .icon.youtube {
  background: var(--youtube-bg);
}

</style>
